import '../css/App.css';
import Header from './Header';
import Home from './Home';
import About from './About';
import Skills from './Skills';
import Services from './Services';
import Work from './Work';
import Contact from './Contact';
import Footer from './Footer';
import React, {useState, useEffect} from 'react';
import Modal from './Modal';
import {motion, AnimatePresence} from 'framer-motion';

function App() {
  const [modal, setModal] = useState(false);
  const [modalInfo, setModalInfo] = useState({});

  const animation = {
    hidden: {
      x: '-100%',
      opacity: 0,
      transition: {
        duration: 0.5,
      },
    },
    visible: {
      x: 0,
      opacity: 1,
      transition: {
        duration: 0.5,
      },
    },
  };
  function handleModal(e) {
    setModal(e);
  }
  function handleModalInfo(e) {
    setModalInfo(e);
  }

  return (
    <>
      {/* <!--=============== BOXICONS ===============--> */}
      <link
        href='https://unpkg.com/boxicons@2.1.1/css/boxicons.min.css'
        rel='stylesheet'
      />

      <Header />

      <main className='main'>
        <Home />

        <About animation={animation} />

        <Skills animation={animation} />

        <Services
          handleModal={handleModal}
          handleModalInfo={handleModalInfo}
          animation={animation}
        />

        <motion.div>
          <AnimatePresence>
            {modal && (
              <Modal
                handleModalInfo={handleModalInfo}
                handleModal={handleModal}
                props={modalInfo}
              />
            )}
          </AnimatePresence>
        </motion.div>

        <Work animation={animation} />

        <Contact animation={animation} />
      </main>

      <Footer />
    </>
  );
}

export default App;
